import moment from 'moment';
import React, { memo, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { deleteRequest } from '../../../utils/axiosRequests';
import {
  deleteConfirmation,
  formatOldPrescriptionData,
  isExistAnyEyeGlass,
  isExistAnyHistory,
  isExistAnyInfertilityData,
  isExistAnyOnExamination,
  isExistAnyRehabData,
  leftOrRightItems,
} from '../../../utils/helpers';
import TemplateModal from '../modals/templateModal';
import DiagnosisView from './diagnosisView';
import RxView from './rxView';
import AdviceView from './views/advice';
import ChiefComplainView from './views/chiefComplain';
import EyeGlassView from './views/eyeGlassView';
import FollowUpView from './views/followUp';
import HistoryView from './views/historyView';
import InfertilityView from './views/infertility';
import InvestigationView from './views/investigation';
import OnExaminationView from './views/onExamination';
import ReferredtoView from './views/referredto';
import RehabilitationView from './views/rehabilitationView';
import SpecialNoteView from './views/specialNoteView';
import TreatmentPlanView from './views/treatmentPlan';

const PatientHistoryRight = ({
  patientData,
  prescriptions,
  setPrescriptions,
  appointment,
  note,
}) => {
  console.log(prescriptions, 'datadata1');
  const prescriptionItems = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.prescriptionItems,
  );
  const [isTemplateModal, setIsTemplateModal] = useState(false);
  const [prescriptionData, setPrescriptionData] = useState({});
  const [openAccordionItems, setOpenAccordionItems] = useState({});

  const userInfo = useSelector((state) => state.authReducer.data);

  const deletePrescription = (prescriptionId) => {
    deleteRequest(`prescriptions/${prescriptionId}`)
      .then((data) => {
        const result = prescriptions.filter(
          (prescription) => prescription.id !== prescriptionId,
        );
        setPrescriptions([...result]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const createTemplateModal = (prescription, e) => {
    setPrescriptionData({
      organizationId: prescription?.organizationId?.id,
      chiefComplains: prescription?.chiefComplains,
      onExaminations: prescription?.onExaminations,
      diagnoses: prescription?.diagnoses,
      histories: prescription?.histories,
      medicines: prescription?.medicines,
      advices: prescription?.advices,
      followUps: prescription?.followUps,
      referredto: prescription?.referredto,
      investigations: prescription?.investigations,
      eyeGlass: prescription?.eyeGlass,
      medicineIds: prescription?.medicineIds,
    });
    setIsTemplateModal(true);
    e.stopPropagation();
  };

  const getFormattedAdvices = (advices) => {
    let formatedAdvices = [];
    let key = 'untitled';
    advices?.forEach((item) => {
      if (item?.title) {
        key = item?.title;
        formatedAdvices[key] = [item];
      } else {
        if (Array.isArray(formatedAdvices[key])) {
          formatedAdvices[key].push(item);
        } else {
          formatedAdvices[key] = [item];
        }
      }
    });
    return formatedAdvices;
  };

  const chiefComplainView = (element, selectedChiefComplains) => {
    if (selectedChiefComplains.length === 0) return false;

    return (
      <ChiefComplainView
        element={element}
        key={'chiefComplain'}
        prescriptionItems={prescriptionItems}
        selectedChiefComplains={selectedChiefComplains}
        isHistoryPage={true}
      />
    );
  };

  const treatmentPlanView = (element, selectedTreatmentPlans) => {
    if (selectedTreatmentPlans?.length === 0) return false;

    return (
      <TreatmentPlanView
        element={element}
        key={'treatmentPlan'}
        prescriptionItems={prescriptionItems}
        selectedTreatmentPlans={selectedTreatmentPlans}
        isHistoryPage={true}
      />
    );
  };

  const historyView = (element, selectedHistories) => {
    if (!isExistAnyHistory(selectedHistories)) return false;

    return (
      <HistoryView
        element={element}
        key={'history'}
        selectedHistories={selectedHistories}
        prescriptionItems={prescriptionItems}
        isHistoryPage={true}
      />
    );
  };

  const viewDiagnosis = (element, selectedDiagnosis, selectedStage) => {
    if (selectedDiagnosis.length === 0 && !selectedStage?.isShow) return false;

    return (
      <DiagnosisView
        element={element}
        key={'diagnosis'}
        selectedDiagnosis={selectedDiagnosis}
        prescriptionItems={prescriptionItems}
        selectedStage={selectedStage}
        isHistoryPage={true}
      />
    );
  };

  const referredToView = (element, selectedReferredto) => {
    if (selectedReferredto?.length === 0 && !selectedReferredto?.length) {
      return false;
    }

    return (
      <ReferredtoView
        element={element}
        key={'referredto'}
        prescriptionItems={prescriptionItems}
        selectedReferredto={selectedReferredto}
        isHistoryPage={true}
      />
    );
  };

  const followUpView = (element, selectedFollowUps) => {
    if (selectedFollowUps?.length === 0) return false;

    return (
      <FollowUpView
        element={element}
        key={'followup'}
        prescriptionItems={prescriptionItems}
        selectedFollowUps={selectedFollowUps}
        isHistoryPage={true}
      />
    );
  };

  const adviceView = (element, selectedAdvices) => {
    if (selectedAdvices.length === 0) return false;

    return (
      <AdviceView
        element={element}
        key={'advice'}
        prescriptionItems={prescriptionItems}
        selectedAdvices={selectedAdvices}
        isHistoryPage={true}
      />
    );
  };

  const investigationView = (element, selectedInvestigations) => {
    if (selectedInvestigations.length === 0) {
      return false;
    }
    return (
      <InvestigationView
        element={element}
        key={'investigation'}
        prescriptionItems={prescriptionItems}
        selectedInvestigations={selectedInvestigations}
        isHistoryPage={true}
      />
    );
  };

  const viewRx = (element, selectedMedicines) => {
    if (selectedMedicines.length === 0) {
      return false;
    }
    return (
      <RxView
        selectedMedicines={selectedMedicines}
        prescriptionItems={prescriptionItems}
        element={element}
        key={'rx'}
        isHistoryPage={true}
      />
    );
  };

  const onExaminationView = (element, selectedOnExamination) => {
    if (!isExistAnyOnExamination(selectedOnExamination)) {
      return false;
    }
    return (
      <OnExaminationView
        element={element}
        key={'onExamination'}
        selectedOnExamination={selectedOnExamination}
        prescriptionItems={prescriptionItems}
        isHistoryPage={true}
      />
    );
  };

  const specialNoteView = (element, specialNotes) => {
    if (specialNotes) {
      if (specialNotes?.length === 0) {
        return false;
      }
    } else {
      return false;
    }
    return (
      <SpecialNoteView
        selectedSpecialNotes={specialNotes}
        prescriptionItems={prescriptionItems}
        element={element}
        key={'specialNote'}
        isHistoryPage={true}
      />
    );
  };

  const viewRehabilitation = (element, selectedRehabilitation) => {
    if (!isExistAnyRehabData(selectedRehabilitation)) {
      return false;
    }
    return (
      <RehabilitationView
        selectedRehabilitation={selectedRehabilitation}
        element={element}
        key={'rehab'}
        prescriptionItems={prescriptionItems}
        isHistoryPage={true}
      />
    );
  };

  const eyeGlassView = (element, selectedEyeGlass) => {
    if (!isExistAnyEyeGlass(selectedEyeGlass)) {
      return false;
    }
    return (
      <EyeGlassView
        selectedEyeGlass={selectedEyeGlass}
        prescriptionItems={prescriptionItems}
        element={element}
        key={'eye-glass'}
        isHistoryPage={true}
      />
    );
  };

  const infertilityView = (element, selectedInfertilities) => {
    if (!isExistAnyInfertilityData(selectedInfertilities)) {
      return false;
    }
    return (
      <InfertilityView
        element={element}
        isHistoryPage={true}
        key={'infertility'}
        prescriptionItems={prescriptionItems}
        selectedInfertilities={selectedInfertilities}
      />
    );
  };

  const addNewRxButton = () => {
    return (
      <div className="add-new-rx mb-3">
        <span>
          <i className="fa fa-plus pr-2"></i>
          Add New Rx
        </span>
      </div>
    );
  };

  const toggleAccordionItem = (key) => {
    setOpenAccordionItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const isAccordionOpen = (key) => !!openAccordionItems[key];

  return (
    <div>
      {appointment && appointment?.status !== 'completed' ? (
        <Link
          to="/prescription"
          state={{
            appointment,
            dob: patientData?.dob,
            history: 'onlyAppointment',
          }}
        >
          {addNewRxButton()}
        </Link>
      ) : (
        <Link
          to={'/prescription'}
          state={{
            patientData: patientData,
            dob: patientData?.dob,
            history: 'new',
          }}
        >
          {addNewRxButton()}
        </Link>
      )}
      {prescriptions.length > 0 && (
        <Row className="mt-2 application-history dotted-border ml-0">
          <Col>
            <Accordion defaultActiveKey={null} alwaysOpen>
              {prescriptions?.map((data, index) => {
                console.log(data, 'datadata');
                if (data?.medicines?.length > 0) {
                  data.medicines = formatOldPrescriptionData(data.medicines);
                }
                return (
                  <Accordion.Item
                    eventKey={index}
                    key={index}
                    className="mb-3 prescription-history"
                  >
                    <Accordion.Header
                      onClick={(e) => toggleAccordionItem(index)}
                    >
                      <div className="justify-content-space-between-wrap pt-2">
                        <div style={{ marginTop: '-4px' }}>
                          <div className="prescription-number-circle">
                            <div>{++index}</div>
                          </div>
                          <span className="accordion-title-text">
                            {data?.createdAt
                              ? moment(data?.createdAt).format('D MMMM, YYYY')
                              : ''}
                          </span>
                        </div>
                        <div className="right-edit-icon">
                          <span
                            className="create-template-btn"
                            style={{
                              display: 'inline-block',
                              color: '#00b38c',
                            }}
                          >
                            {isAccordionOpen(index) ? (
                              <i className="fa fa-eye-slash"></i>
                            ) : (
                              <i className="fa fa-eye"></i>
                            )}
                            {isAccordionOpen(index) ? ' Hide' : ' Show'}{' '}
                            Prescription
                          </span>
                          |
                          <span
                            className="create-template-btn"
                            onClick={(e) => createTemplateModal(data, e)}
                            style={{ width: '6.2rem', display: 'inline-block' }}
                          >
                            <i className="fa fa-file"></i> Templates
                          </span>
                          |
                          <Link
                            to={'/prescription'}
                            className="pres-edit"
                            style={{ width: '6.6rem', display: 'inline-block' }}
                            state={{
                              prescription: data,
                              dob: data?.patientId?.dob,
                              note: note,
                              history: 'editFromHistory',
                            }}
                          >
                            <i className="fa fa-edit"></i> Follow Up
                          </Link>
                          {userInfo?.id !== '674d627165d3012fe0819c4b' ? (
                            <>
                              |
                              <span
                                className="pres-del"
                                style={{
                                  width: '4.3rem',
                                  display: 'inline-block',
                                }}
                                onClick={(e) => {
                                  deleteConfirmation(
                                    deletePrescription,
                                    data.id,
                                  );
                                  e.stopPropagation();
                                }}
                              >
                                <i className="fa fa-trash-alt"></i> Delete
                              </span>{' '}
                            </>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                      <div
                        className="justify-content-centered mr-1 mt-4 pt-3 pb-2"
                        style={{ borderTop: '1px solid #e9e9e9' }}
                      >
                        <span className="indivisual-prescription-stat">
                          Chief Complain:{' '}
                          {data.chiefComplains.length
                            ? data.chiefComplains.length
                            : 0}
                        </span>
                        <span className="indivisual-prescription-stat">
                          Diagnosis:{' '}
                          {data.diagnoses.length ? data.diagnoses.length : 0}
                        </span>
                        <span className="indivisual-prescription-stat">
                          Rx:{' '}
                          {data.chiefComplains.length
                            ? data.medicines.length
                            : 0}
                        </span>
                        <span className="indivisual-prescription-stat">
                          Investigation:{' '}
                          {data.investigations.length
                            ? data.investigations.length
                            : 0}
                        </span>
                        <span className="indivisual-prescription-stat">
                          Advice:{' '}
                          {data.advices.length ? data.advices.length : 0}
                        </span>
                        <span className="indivisual-prescription-stat">
                          Follow up:{' '}
                          {data.followUps.length ? data.followUps.length : 0}
                        </span>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      {/* <div className="right-edit-icon">
                        <span
                          className="create-template-btn"
                          onClick={() => createTemplateModal(data)}
                        >
                          <i className="fa fa-file"></i> Templates
                        </span>
                        |
                        <Link
                          to={'/prescription'}
                          className="pres-edit"
                          state={{
                            prescription: data,
                            dob: data?.patientId?.dob,
                            note: note,
                            history: 'editFromHistory',
                          }}
                        >
                          <i className="fa fa-edit"></i> Edit
                        </Link>
                        |
                        <span
                          className="pres-del"
                          onClick={() =>
                            deleteConfirmation(deletePrescription, data.id)
                          }
                        >
                          <i className="fa fa-trash-alt"></i> Delete
                        </span>
                      </div> */}
                      <div className="row prescription-body pt-2">
                        {leftOrRightItems(prescriptionItems, 'left').length >
                          0 && (
                          <div className="prescription-body-left">
                            {leftOrRightItems(prescriptionItems, 'left').map(
                              (element) => {
                                if (element.name === 'chief-complain') {
                                  return chiefComplainView(
                                    element,
                                    data?.chiefComplains,
                                  );
                                } else if (element.name === 'treatment-plan') {
                                  return treatmentPlanView(
                                    element,
                                    data?.treatmentPlans,
                                  );
                                } else if (element.name === 'referred-to') {
                                  return referredToView(
                                    element,
                                    data?.referredto,
                                  );
                                } else if (element.name === 'history') {
                                  return historyView(element, data?.histories);
                                } else if (element.name === 'diagnosis') {
                                  return viewDiagnosis(
                                    element,
                                    data?.diagnoses,
                                    data?.staging,
                                  );
                                } else if (element.name === 'follow-up') {
                                  return followUpView(element, data?.followUps);
                                } else if (element.name === 'investigation') {
                                  return investigationView(
                                    element,
                                    data?.investigations,
                                  );
                                } else if (element.name === 'rx') {
                                  return viewRx(element, data?.medicines);
                                } else if (element.name === 'on-examination') {
                                  return onExaminationView(
                                    element,
                                    data?.onExaminations,
                                  );
                                } else if (element.name === 'special-note') {
                                  return specialNoteView(
                                    element,
                                    data?.specialNotes,
                                  );
                                } else if (element.name === 'rehabilitation') {
                                  return viewRehabilitation(
                                    element,
                                    data?.rehabilitation,
                                  );
                                } else if (element.name === 'advice') {
                                  return adviceView(element, data?.advices);
                                } else if (element.name === 'eye-glass') {
                                  return eyeGlassView(element, data?.eyeGlass);
                                } else if (element.name === 'infertility') {
                                  return infertilityView(
                                    element,
                                    data?.infertilities,
                                  );
                                }
                              },
                            )}
                          </div>
                        )}
                        {leftOrRightItems(prescriptionItems, 'right').length >
                          0 && (
                          <div className="prescription-body-right">
                            {leftOrRightItems(prescriptionItems, 'right').map(
                              (element) => {
                                if (element.name === 'chief-complain') {
                                  return chiefComplainView(
                                    element,
                                    data?.chiefComplains,
                                  );
                                } else if (element.name === 'treatment-plan') {
                                  return treatmentPlanView(
                                    element,
                                    data?.treatmentPlans,
                                  );
                                } else if (element.name === 'referred-to') {
                                  return referredToView(
                                    element,
                                    data?.referredto,
                                  );
                                } else if (element.name === 'history') {
                                  return historyView(element, data?.histories);
                                } else if (element.name === 'diagnosis') {
                                  return viewDiagnosis(
                                    element,
                                    data?.diagnoses,
                                    data?.staging,
                                  );
                                } else if (element.name === 'follow-up') {
                                  return followUpView(element, data?.followUps);
                                } else if (element.name === 'advice') {
                                  return adviceView(element, data?.advices);
                                } else if (element.name === 'rx') {
                                  return viewRx(element, data?.medicines);
                                } else if (element.name === 'on-examination') {
                                  return onExaminationView(
                                    element,
                                    data?.onExaminations,
                                  );
                                } else if (element.name === 'special-note') {
                                  return specialNoteView(
                                    element,
                                    data?.specialNotes,
                                  );
                                } else if (element.name === 'rehabilitation') {
                                  return viewRehabilitation(
                                    element,
                                    data?.rehabilitation,
                                  );
                                } else if (element.name === 'eye-glass') {
                                  return eyeGlassView(element, data?.eyeGlass);
                                } else if (element.name === 'infertility') {
                                  return infertilityView(
                                    element,
                                    data?.infertilities,
                                  );
                                }
                              },
                            )}
                          </div>
                        )}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
            <TemplateModal
              isTemplateModal={isTemplateModal}
              setIsTemplateModal={setIsTemplateModal}
              templateInput={prescriptionData}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default memo(PatientHistoryRight);
